(function () {
  'use strict';

  var API_KEY = 'HKProductDescriptionUI';
  var ROOT_SELECTOR = '[data-hk-product-description]';

  if (window[API_KEY]) {
    window[API_KEY].init(document);
    return;
  }

  function hasMeaningfulContent(fragment) {
    if (!fragment) return false;

    if ((fragment.textContent || '').trim()) return true;

    return Boolean(
      fragment.querySelector &&
        fragment.querySelector('img, video, iframe, table, ul, ol, blockquote, figure')
    );
  }

  function fragmentBetween(container, startNode, endNode) {
    var range = document.createRange();
    range.selectNodeContents(container);

    if (startNode) range.setStartAfter(startNode);
    if (endNode) range.setEndBefore(endNode);

    return range.cloneContents();
  }

  function HKProductDescription(root) {
    this.root = root;
    this.source = root.querySelector('[data-hkpd-source]');
    this.tablist = root.querySelector('[data-hkpd-tabs]');
    this.panelContainer = root.querySelector('[data-hkpd-panels]');
    this.tabs = [];
    this.panels = [];
    this.activeIndex = 0;
    this.mobileMedia = window.matchMedia('(max-width: 749px)');
    this.handleMediaChange = this.updateOrientation.bind(this);

    if (!this.source || !this.tablist || !this.panelContainer) return;

    this.build();
    this.updateOrientation();

    if (this.mobileMedia.addEventListener) {
      this.mobileMedia.addEventListener('change', this.handleMediaChange);
    } else if (this.mobileMedia.addListener) {
      this.mobileMedia.addListener(this.handleMediaChange);
    }
  }

  HKProductDescription.prototype.getGroups = function () {
    var headings = Array.prototype.slice.call(this.source.querySelectorAll('h3'));
    var groups = [];
    var fallbackTitle = this.root.dataset.fallbackTitle || 'Description';

    if (!headings.length) {
      groups.push({
        title: fallbackTitle,
        content: this.source.cloneNode(true)
      });
      return groups;
    }

    // The first tab is always the main Description. Any content before the
    // first H3 belongs here; each H3 after it becomes its own tab.
    groups.push({
      title: fallbackTitle,
      content: fragmentBetween(this.source, null, headings[0])
    });

    headings.forEach(function (heading, index) {
      groups.push({
        title: (heading.textContent || '').trim() || fallbackTitle,
        content: fragmentBetween(this.source, heading, headings[index + 1] || null)
      });
    }, this);

    return groups;
  };

  HKProductDescription.prototype.build = function () {
    var groups = this.getGroups();
    var sectionId = this.root.dataset.sectionId || 'product-description';
    var emptyText = this.root.dataset.emptyText || 'Details will be added soon.';
    var tabFragment = document.createDocumentFragment();
    var panelFragment = document.createDocumentFragment();
    var self = this;

    groups.forEach(function (group, index) {
      var tabId = 'HKDescriptionTab-' + sectionId + '-' + index;
      var panelId = 'HKDescriptionPanel-' + sectionId + '-' + index;
      var tab = document.createElement('button');
      var title = document.createElement('span');
      var panel = document.createElement('article');
      var body = document.createElement('div');

      tab.type = 'button';
      tab.className = 'hkpd__tab';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.tabIndex = index === 0 ? 0 : -1;

      title.className = 'hkpd__tab-title';
      title.textContent = group.title;

      tab.appendChild(title);
      tab.addEventListener('click', function () {
        self.activate(index);
      });
      tab.addEventListener('keydown', function (event) {
        self.handleKeydown(event, index);
      });

      panel.className = 'hkpd__panel';
      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);
      panel.tabIndex = 0;
      panel.hidden = index !== 0;

      body.className = 'hkpd__body rte';
      if (hasMeaningfulContent(group.content)) {
        body.appendChild(group.content);
      } else {
        var empty = document.createElement('p');
        empty.className = 'hkpd__empty';
        empty.textContent = emptyText;
        body.appendChild(empty);
      }

      panel.appendChild(body);
      tabFragment.appendChild(tab);
      panelFragment.appendChild(panel);
      self.tabs.push(tab);
      self.panels.push(panel);
    });

    this.tablist.replaceChildren(tabFragment);
    this.panelContainer.replaceChildren(panelFragment);
    this.tablist.hidden = false;
    this.panelContainer.hidden = false;
    this.source.hidden = true;
    this.root.classList.add('is-enhanced');
  };

  HKProductDescription.prototype.activate = function (index, options) {
    if (!this.tabs[index] || index === this.activeIndex) {
      if (options && options.focus && this.tabs[index]) {
        this.tabs[index].focus({ preventScroll: true });
      }
      return;
    }

    this.tabs.forEach(function (tab, tabIndex) {
      var isActive = tabIndex === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach(function (panel, panelIndex) {
      panel.hidden = panelIndex !== index;
    });

    this.activeIndex = index;

    if (options && options.focus) {
      this.tabs[index].focus({ preventScroll: true });
    }

    if (this.mobileMedia.matches && this.tablist.scrollWidth > this.tablist.clientWidth) {
      var tab = this.tabs[index];
      var targetLeft = tab.offsetLeft - (this.tablist.clientWidth - tab.offsetWidth) / 2;
      this.tablist.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  };

  HKProductDescription.prototype.handleKeydown = function (event, index) {
    var nextIndex;
    var lastIndex = this.tabs.length - 1;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = index === lastIndex ? 0 : index + 1;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = index === 0 ? lastIndex : index - 1;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = lastIndex;
    }

    if (typeof nextIndex === 'undefined') return;

    event.preventDefault();
    this.activate(nextIndex, { focus: true });
  };

  HKProductDescription.prototype.updateOrientation = function () {
    if (!this.tablist) return;
    this.tablist.setAttribute('aria-orientation', 'vertical');
  };

  HKProductDescription.prototype.destroy = function () {
    if (this.mobileMedia.removeEventListener) {
      this.mobileMedia.removeEventListener('change', this.handleMediaChange);
    } else if (this.mobileMedia.removeListener) {
      this.mobileMedia.removeListener(this.handleMediaChange);
    }
  };

  var instances = new WeakMap();

  function getRoots(scope) {
    if (!scope) return [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) return [scope];
    if (!scope.querySelectorAll) return [];
    return Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR));
  }

  function init(scope) {
    getRoots(scope || document).forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new HKProductDescription(root));
    });
  }

  function destroy(scope) {
    getRoots(scope).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
      instances.delete(root);
    });
  }

  window[API_KEY] = {
    init: init,
    destroy: destroy
  };

  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
